export const trulifData = [
  {
    id: 1,
    name: "Momentum",
    managed_by: "Allison",
    token_return: "+74%",
    value_managed: "1,200,000",
    assets: [
      {
        name: "CELO",
        per: "35",
        amount: "420,000",
      },
      {
        name: "CRV",
        per: "25",
        amount: "300,000",
      },
      {
        name: "AVAX",
        per: "25",
        amount: "300,000",
      },
      {
        name: "UBE",
        per: "15",
        amount: "180,000",
      },
    ],
    strategy: "Momentum + Price action",
  },
  {
    id: 2,
    name: "Ubeswap Eco",
    managed_by: "Bryan",
    token_return: "+26%",
    value_managed: "300,000",
    assets: [
      {
        name: "WMATIC",
        per: "10",
        amount: "30,000",
      },
      {
        name: "CRV",
        per: "10",
        amount: "30,000",
      },
      {
        name: "AVAX",
        per: "10",
        amount: "30,000",
      },
      {
        name: "WBTC",
        per: "10",
        amount: "30,000",
      },
      {
        name: "BNB",
        per: "10",
        amount: "30,000",
      },
      {
        name: "cETH",
        per: "10",
        amount: "30,000",
      },
      {
        name: "CELO",
        per: "10",
        amount: "30,000",
      },
      {
        name: "KNX",
        per: "10",
        amount: "30,000",
      },
      {
        name: "MOBI",
        per: "10",
        amount: "30,000",
      },
    ],
    strategy:
      "Equal weight, targeting top performance - plan for weekly rebalance.",
  },
  {
    id: 3,
    name: "Bull Flag",
    managed_by: "Alex",
    token_return: "+86%",
    value_managed: "1,400,000",
    assets: [
      {
        name: "SOL",
        per: "45",
        amount: "630,000",
      },
      {
        name: "CELO",
        per: "35",
        amount: "490,000",
      },
      {
        name: "AVAX",
        per: "20",
        amount: "280,000",
      },
    ],
    strategy: "Strong uptrend indicator strategy.",
  },

  {
    id: 4,
    name: "Ride the Bull",
    managed_by: "Lee",
    token_return: "+165%",
    value_managed: "2,500,000",
    assets: [
      {
        name: "SOL",
        per: "30",
        amount: "750,000",
      },
      {
        name: "CELO",
        per: "20",
        amount: "500,000",
      },
      {
        name: "AVAX",
        per: "35",
        amount: "875,000",
      },
      {
        name: "CRV",
        per: "15",
        amount: "375,000",
      },
    ],
    strategy:
      "Follow the momentum & ride the bull, then move to cUSD when the market is flat. And then repeat....",
  },
  {
    id: 5,
    name: "Layer 1",
    managed_by: "Hemant",
    token_return: "+7%",
    value_managed: "4,700,000",
    assets: [
      {
        name: "SOL",
        per: "25",
        amount: "1,175,000",
      },
      {
        name: "CELO",
        per: "25",
        amount: "1,175,000",
      },
      {
        name: "cETH",
        per: "25",
        amount: "1,175,000",
      },
      {
        name: "WBTC",
        per: "25",
        amount: "1,175,000",
      },
      {
        name: "AVAX",
        per: "25",
        amount: "1,175,000",
      },
    ],
    strategy: "Invest in layer 1 tokens only.",
  },
  {
    id: 6,
    name: "Lower Volatility",
    managed_by: "Beth",
    token_return: "+45%",
    value_managed: "600,000",
    assets: [
      {
        name: "mCUSD",
        per: "45",
        amount: "270,000",
      },
      {
        name: "mCELO",
        per: "30",
        amount: "180,000",
      },
      {
        name: "WETH",
        per: "15",
        amount: "90,000",
      },
      {
        name: "WBTC",
        per: "10",
        amount: "60,000",
      },
    ],
    strategy:
      "Minimize the volatility of the portfolio value while maintain both the income & growth.",
  },
];
